<template>
    <div class="col-12">
        <div class="row">
            <div class="col-12">
                <div class="card-body settings-toggle-block">
                    <div class="settings-toggle-block__label">
                        <p class="category-title">Mini Sidebar</p>
                        <p class="category">
                            Show navigation panel on hover only.
                        </p>
                    </div>
                    <div class="toggle">
                        <base-switch
                            id="miniSidebar"
                            v-model="miniSidebar"
                            type="primary"
                            on-text="On"
                            off-text="Off"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isClient" class="row">
            <div class="col-12">
                <div class="card-body settings-toggle-block">
                    <div class="settings-toggle-block__label">
                        <p class="category-title">Receipt Log Unit List Only</p>
                        <p class="category">
                            See a summary of all units instead of seeing a
                            summary of all receipt logs.
                        </p>
                    </div>
                    <div class="toggle">
                        <base-switch
                            v-model="receiptLogDetailMasterList"
                            type="primary"
                            on-text="On"
                            off-text="Off"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { BaseSwitch } from "src/components/UI";

export default {
    name: "AccountSettings",
    components: {
        BaseSwitch,
    },
    props: {
        isClient: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            miniSidebar: JSON.parse(
                localStorage.getItem("settings_minisidebar") ?? "true",
            ),
            receiptLogDetailMasterList: JSON.parse(
                localStorage.getItem("settings_receiptlogdetailmasterlist") ??
                    "false",
            ),
        };
    },
    watch: {
        miniSidebar(enabled) {
            localStorage.setItem("settings_minisidebar", enabled);
            if (enabled) {
                this.$sidebar.minimize();
            } else {
                this.$sidebar.maximize();
            }
        },
        receiptLogDetailMasterList(enabled) {
            localStorage.setItem(
                "settings_receiptlogdetailmasterlist",
                enabled,
            );
        },
    },
};
</script>
<style lang="scss">
.settings-toggle-block {
    display: flex;
}
.settings-toggle-block__label {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}
.toggle {
    display: flex;
    align-items: center;
}
</style>
